export const isAndroid = (userAgent = navigator.userAgent) => {
  return Boolean(userAgent && /(android)/i.test(userAgent));
};
